import { Injectable } from '@angular/core';
import { Product } from '@core/models/product.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface ProductState extends EntityState<Product> {}

export function createInitialState(): ProductState {
  return null;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'products', resettable: true })
export class ProductStore extends EntityStore<ProductState> {
  constructor() {
    super(createInitialState());
  }
}
